import React, { useMemo } from 'react';

import { usePurchasingStatuses } from 'pages/purchasing/PurchaseTargetsPage/PurchaseTargetLinesPage/utils';

import { calcLine, calcOp, calcProp, Equation } from 'components/recipes/equation/Equation';

import { formatUSD, formatNumber } from 'utils/formatting';

import { EquationPopover } from './EquationPopover';

export const PriorityDispositionEquationPopover = ({
  type = 'Cost',
  total = 0,
  specialOrderQty = 0,
  backorderQty = 0,
}: {
  total: number | string;
  type?: 'Cost' | 'Lines';
  specialOrderQty?: string | number;
  backorderQty?: string | number;
}) => {
  const { shouldShowSpecialOrderWarning } = usePurchasingStatuses();
  const calcOperation = useMemo(() => {
    const formatValue = type === 'Cost' ? formatUSD : formatNumber;
    const baseCalculationOperations = [
      calcProp(`Priority ${type}`, formatValue(total)),
      calcOp('='),
      calcProp(`Backorder `, formatValue(backorderQty)),
    ];
    if (shouldShowSpecialOrderWarning) {
      baseCalculationOperations.push(calcOp('+'), calcProp(`Special `, formatValue(specialOrderQty)));
    }
    return baseCalculationOperations;
  }, [backorderQty, shouldShowSpecialOrderWarning, specialOrderQty, total, type]);
  return (
    <EquationPopover title={`${type} Breakdown`}>
      <Equation lines={[calcLine(...calcOperation)]} />
    </EquationPopover>
  );
};
